import { render } from "./CookieInformation.vue?vue&type=template&id=8d818ab2&scoped=true"
import script from "./CookieInformation.vue?vue&type=script&lang=js"
export * from "./CookieInformation.vue?vue&type=script&lang=js"

import "./CookieInformation.vue?vue&type=style&index=0&id=8d818ab2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d818ab2"]])

export default __exports__